namespace TabAurous.Finance {
    export interface PaymentDetailsForm {
        LedgerId: Serenity.LookupEditor;
        Mode: PaymentModesEditor;
        Amount: Serenity.DecimalEditor;
        ExchangeRate: Serenity.DecimalEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
        RefNo: Serenity.StringEditor;
    }

    export class PaymentDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.PaymentDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PaymentDetailsForm.init)  {
                PaymentDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = PaymentModesEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.DateEditor;

                Q.initFormType(PaymentDetailsForm, [
                    'LedgerId', w0,
                    'Mode', w1,
                    'Amount', w2,
                    'ExchangeRate', w2,
                    'ChequeNo', w3,
                    'ChequeDate', w4,
                    'RefNo', w3
                ]);
            }
        }
    }
}
